import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CircleCheck } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
export const RadioLarge = forwardRef(({ type = 'radio', checked, children, ...props }, forwardedRef) => {
    const customClassnames = cn([
        'flex flex-1 gap-2 items-center justify-center',
        'text-sm font-medium text-gray-600',
        'rounded-md border border shadow-xs',
        'px-8 py-4',
        'bg-gray-50',
        'transition-colors',
        'cursor-pointer',
    ]);
    return (_jsxs("label", { className: 'w-full', children: [_jsx("input", { ref: forwardedRef, className: 'hidden', type: type, checked: checked, ...props }), _jsxs("div", { className: cn(customClassnames, {
                    ['bg-green-50']: checked,
                    ['hover:bg-gray-100']: !checked,
                }), children: [_jsx(CircleCheck, { strokeWidth: 1.5, className: cn('shrink-0 transition-all [&>path]:scale-100 ease-in-out duration-250', {
                            ['text-green-600']: checked,
                            ['text-gray-300']: !checked,
                            ['[&>path]:scale-0']: !checked,
                        }) }), children] })] }));
});
export default RadioLarge;
